module.exports = __webpack_public_path__ + "img/fendanyun_02.af06b984.jpg";